var map = {
	"./1/symbol_0.png": 38983,
	"./1/symbol_1.png": 63198,
	"./1/symbol_10.png": 83228,
	"./1/symbol_11.png": 19141,
	"./1/symbol_12.png": 7662,
	"./1/symbol_2.png": 99925,
	"./1/symbol_3.png": 88300,
	"./1/symbol_4.png": 37699,
	"./1/symbol_5.png": 31514,
	"./1/symbol_6.png": 7761,
	"./1/symbol_7.png": 59368,
	"./1/symbol_8.png": 22783,
	"./1/symbol_9.png": 68982,
	"./2/symbol_0.png": 66622,
	"./2/symbol_1.png": 42407,
	"./2/symbol_10.png": 72327,
	"./2/symbol_11.png": 3486,
	"./2/symbol_12.png": 5589,
	"./2/symbol_2.png": 91724,
	"./2/symbol_3.png": 3349,
	"./2/symbol_4.png": 51290,
	"./2/symbol_5.png": 41123,
	"./2/symbol_6.png": 62792,
	"./2/symbol_7.png": 11185,
	"./2/symbol_8.png": 72406,
	"./2/symbol_9.png": 26207,
	"./3/symbol_0.png": 38049,
	"./3/symbol_1.png": 65336,
	"./3/symbol_10.png": 70058,
	"./3/symbol_12.png": 79512,
	"./3/symbol_2.png": 56179,
	"./3/symbol_3.png": 89066,
	"./3/symbol_4.png": 73733,
	"./3/symbol_5.png": 56220,
	"./3/symbol_6.png": 44951,
	"./3/symbol_7.png": 71310,
	"./3/symbol_8.png": 86873,
	"./3/symbol_9.png": 71120,
	"./4/symbol_0.png": 73976,
	"./4/symbol_1.png": 95105,
	"./4/symbol_10.png": 83765,
	"./4/symbol_12.png": 39175,
	"./4/symbol_2.png": 54026,
	"./4/symbol_3.png": 85939,
	"./4/symbol_4.png": 72188,
	"./4/symbol_5.png": 24453,
	"./4/symbol_6.png": 96622,
	"./4/symbol_7.png": 96119,
	"./4/symbol_8.png": 79760,
	"./4/symbol_9.png": 86009,
	"./gold1.png": 10947,
	"./gold2.png": 9320,
	"./gold3.png": 23537,
	"./gold4.png": 82526,
	"./silver1.png": 82352,
	"./silver2.png": 47755,
	"./silver3.png": 84098,
	"./silver4.png": 76893
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26105;